import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/34_card_back_polar_bear/34_card_back_polar_bear"
 * Contains 1 texture(s)
 */
export class CardsBacks34CardBackPolarBearAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/34_card_back_polar_bear/34_card_back_polar_bear';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '34_polar_bear.png'
    ] as const;
}
